var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_1828774",
    clipPath: "url(#clip0_0_45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.30999 7.00044L13.6411 2.66935C14.1196 2.19081 14.1196 1.41498 13.6411 0.93719L13.0637 0.359802C12.585 -0.118887 11.8092 -0.118887 11.3314 0.359802L7.00044 4.69073L2.66935 0.358905C2.19081 -0.119635 1.41498 -0.119635 0.93719 0.358905L0.358905 0.936293C-0.119635 1.41498 -0.119635 2.19081 0.358905 2.66861L4.69073 7.00044L0.359802 11.3314C-0.118887 11.8101 -0.118887 12.5859 0.359802 13.0637L0.93719 13.6411C1.41573 14.1196 2.19156 14.1196 2.66935 13.6411L7.00044 9.30999L11.3314 13.6411C11.8101 14.1196 12.5859 14.1196 13.0637 13.6411L13.6411 13.0637C14.1196 12.585 14.1196 11.8092 13.6411 11.3314L9.30999 7.00044Z",
    fill: "#2D3035"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.764ed597c62dfd38cca6277c80a6964a.svg";
export { ForwardRef as ReactComponent };